import React from 'react';
import _ from 'lodash';

import styles from './summary-group-placeholder.module.scss';

export const SummaryGroupPlaceholder: React.FC = () => (
    <div className={styles.container}>
        <div className={styles.title} />
        {_.range(3).map((index) => (
            <div className={styles.descriptionContainer} key={index}>
                <div className={styles.description} />
                <div className={styles.price} />
            </div>
        ))}
    </div>
);
